import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=32b1e576&scoped=true"
import script from "./AppSwitcher.vue?vue&type=script&lang=js"
export * from "./AppSwitcher.vue?vue&type=script&lang=js"
import style0 from "./AppSwitcher.vue?vue&type=style&index=0&id=32b1e576&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1e576",
  null
  
)

export default component.exports